import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.53 5.97-3-3a.75.75 0 0 0-1.06 0l-9 9a.75.75 0 0 0-.22.53v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .53-.219l9-9a.75.75 0 0 0 0-1.061m-9.84 8.78H9.75v-1.94l6-6 1.94 1.94zm7.06-7.06-1.94-1.94L18 4.56l1.94 1.94zM21 12.5V20a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 20V5a1.5 1.5 0 0 1 1.5-1.5H12A.75.75 0 1 1 12 5H4.5v15h15v-7.5a.75.75 0 1 1 1.5 0"
    }, null, -1)
  ])))
}
export default { render: render }